import { render } from "./attentive-widget.vue?vue&type=template&id=325ed0f8&scoped=true"
import script from "./attentive-widget.vue?vue&type=script&lang=js"
export * from "./attentive-widget.vue?vue&type=script&lang=js"

import "./attentive-widget.vue?vue&type=style&index=0&id=325ed0f8&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325ed0f8"]])

export default __exports__